import { Services } from "components/Condominiums/Services";

export const ListServices = () => {
  return (
    <Services />
  );
};
